import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  private url: string = environment.host;

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token: string = sessionStorage.getItem(environment.tokenName);
    const headers: { [key: string]: string } = {};

    if (token) {
      headers['authorization'] = `Bearer ${token}`;
    }

    let clonedReq = req;

    if (req.method === 'GET') {
      const separator = req.url.indexOf('?') === -1 ? '?' : '&';
      clonedReq = req.clone({
        url: `${req.url}${separator}_t=${new Date().getTime()}`,
        setHeaders: headers
      });
    } else {
      clonedReq = req.clone({
        setHeaders: headers
      });
    }

    return next.handle(clonedReq).pipe(
      catchError((err: HttpErrorResponse) => this.controlarError(err))
    );
  }

  private controlarError(err: HttpErrorResponse): Observable<never> {
    if (err.status === 401) {
      // Limpiar storage para que no quede caché de sesión expirada
      sessionStorage.clear();
      localStorage.clear();
      this.router.navigateByUrl('/login');
    }
    return throwError(err);
  }
}
